
















































































































































import Vue from 'vue'
import AppSearchBar from '@/components/AppSearchBar.vue'
import AppToolbar from '@/components/AppToolbar.vue'
import { debounce } from 'debounce'
import ScrollPosition, { ScrollPanel } from '@/types/components/ScrollPosition.interface'
import { goBack } from '@/utility/helpers'
import Tenant from '@/types/Tenant.interface'
import TriPanel from '@/types/components/TriPanel.interface'
export default Vue.extend({
    components: { AppSearchBar, AppToolbar },
    props: {
        //  Determines if the back button should be hidden (mobile only)
        backHidden: {
            type: Boolean,
            default: false
        },
        //  Determine if scroll direction is reversed in the center panel
        centerReversed: {
            type: Boolean,
            default: false
        },
        //  Toolbar properties that bind the tri-panel toolbar
        toolbar: {
            type: Object,
            required: false
        },
        //  Determines if we show full tripanel
        displayFull: {
            type: Boolean,
            default: true
        },
        //  Determines if we show border on the bottom style
        clearBottom: {
            type: Boolean,
            default: false
        },
        //  Determines if we shower border on the left top style
        clearLeftTop: {
            type: Boolean,
            default: false
        },
        //  Determines if we show border on the top style
        clearTop: {
            type: Boolean,
            default: false
        },
        //  Determines if we hide the "details" button
        hideDetails: {
            type: Boolean,
            default: false
        },
        //  Height for our left top
        heightLeftTop: {
            type: String,
            default: '56px'
        },
        //  The id used to store the tripanel state in the vuex store (must be unique!)
        id: {
            type: String,
            required: true
        },
        //  Determines if we have a loading bar at the top
        loader: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //  The current tri-panel column (mobile only)
            step: 1,
            //  Determines if the right-slot is shown (desktop only)
            more: false,
            //  Determines if we have finished mounting this component
            mounted: false,
            //  Determines if mobile seach should be shown
            showMobileSearch: null,
            //  Styling for the inner panels
            styleContent: {
                // height: 0,
                maxHeight: '100%'
                // minHeight: '100%'
            }
        }
    },
    mounted() {
        //  If a channel is already set, navigate to step 2 (mobile only)
        if (this.$route.query.channel) this.step = 2

        //  If new message is the query, navigate to step 2 (mobile only)
        if (this.$route.query.newMessage) this.step = 2

        //  If the persisted triPanel does NOT exist, create it
        if (!this.triPanel) {
            //  Assemble the triPanel
            const triPanel: TriPanel = {
                id: this.id,
                showMore: this.showMore
            }

            //  Add the triPanel to the store
            this.$store.commit('triPanelSet', triPanel)
        }

        //  We have finished mounting
        this.mounted = true
    },
    computed: {
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        isMobile(): boolean {
            return this.$store.getters.isMobile() || this.$vuetify.breakpoint.xsOnly
        },
        mobileStyle(): object {
            return {
                // flexGrow: 1,
                height: '100%',
                maxHeight: '100%',
                maxWidth: '100%',
                minWidth: '100%',
                width: '0px'
            }
        },
        //  The style applied to the component wrapper
        panelsStyle(): object {
            //  Our margin depends on our breakpoint
            const margin =
                {
                    xs: '0px 0px 0px 0px',
                    sm: '0px 10px 0px 10px'
                }[this.$vuetify.breakpoint.name] || '0px 20px 0px 10px'

            //  Our styles for our panel
            return {
                background: 'white',
                borderRadius: '10px',
                // flexGrow: 1,
                height: '100%',
                overflow: 'hidden',
                margin: margin,
                boxShadow: this.$vuetify.breakpoint.smAndDown
                    ? ''
                    : '5px 5px 10px 0px rgba(189,189,189,1)'
                // position: 'relative'
            }
        },
        //  Determines if the content slot is shown (desktop only)
        showContent(): boolean {
            //  If the slot is not set, hide the content
            if (!this.$slots.content) return false

            //  If we are on a medium screen, and 'more' set true, we hide the content slot (desktop only)
            if (this.$vuetify.breakpoint.mdOnly && this.more) return false

            //  Else, we default to showing the content slot
            return true
        },
        //  Determines if the right slot is shown (desktop only)
        showRight(): boolean {
            //  If the slot is not set, hide the content
            if (!this.$slots.content) return false

            //  The right-slot is always bound to the 'more' property
            return this.more
        },
        //  Gets/Sets the 'more' value (also saves the state to LocalStorage)
        showMore: {
            get(): boolean {
                if (!this.tenant) return false

                //  Get the saved setting from LocalStorage
                let showMore = JSON.parse(
                    localStorage.getItem(`${this.$route.name}-showMore-${this.tenant.id}`)
                )

                //  If the setting does NOT exist in local storage, return default
                if (!showMore) return this.more

                //  Else, set 'more' to the saved setting
                this.more = showMore

                //  Else, return 'more'
                return this.more
            },
            set(bool: boolean): void {
                //  Save the setting to localStorage
                localStorage.setItem(
                    `${this.$route.name}-showMore-${this.tenant.id}`,
                    String(bool)
                )

                //  Set the tri-panel 'more' state
                this.more = bool

                //  Update our Vuex Store
                this.triPanel.showMore = bool
            }
        },
        //  The style applied to 'bottom' slots
        styleBottom(): object {
            //  If clear bottom is true, just return nothing
            if (this.clearBottom) return {}
            return {
                borderTop: `1px solid ${this.$colors.grey.lighten2}`
            }
        },
        //  The style applied to the placerholder container
        styleContainer(): object {
            return {
                borderRight: `1px solid ${this.$colors.grey.lighten2}`,
                flexGrow: 1
            }
        },
        //  The style applied to the 'left' panel
        styleLeft(): object {
            //  Check if the left panel is the only panel that exists
            const isSinglePanel = !this.$slots.content && !this.$slots.right

            //  If 'left' is a single panel, set its width to 100%, else use '30%'
            const width = isSinglePanel ? '100%' : '30%'

            return {
                ...this.styleContent,
                borderRight: `1px solid ${this.$colors.grey.lighten2}`,
                // flexGrow: 1,
                maxWidth: width,
                minWidth: '350px',
                width: 0
            }
        },
        styleLeftTop(): object {
            //  If clearTop is true, don't have a border on bottom
            const borderStyle = this.clearLeftTop
                ? ''
                : `1px solid ${this.$colors.grey.lighten2}`
            return {
                display: 'flex',
                borderBottom: borderStyle,
                minHeight: this.heightLeftTop
            }
        },
        //  The style applied to the 'right' panel
        styleRight(): object {
            return {
                ...this.styleContent,
                borderLeft: `1px solid ${this.$colors.grey.lighten2}`
            }
        },
        //  The style applied to the 'top' slots
        styleTop(): object {
            //  If clearTop is true, don't have a border on bottom
            const borderStyle = this.clearTop
                ? ''
                : `1px solid ${this.$colors.grey.lighten2}`
            return {
                display: 'flex',
                borderBottom: borderStyle,
                minHeight: '56px'
            }
        },
        tenant(): Tenant {
            return this.$store.getters.tenant
        },
        triPanel(): TriPanel {
            return this.$store.getters.triPanel(this.id)
        }
    },
    methods: {
        //  Handle the scroll event for each panel
        onContentScroll: debounce(function (event, panel: string): void {
            //  Get the DOM from the event
            const content = event.target

            //  Get the height of the content
            const contentHeight = content.clientHeight

            //  Get current scroll location
            const current = content.scrollTop

            //  Check if the scroll event is coming from a reversed content
            const isReversed = panel === 'Center' && this.centerReversed

            //  Determine if the scroll position is at the top
            const top = isReversed
                ? current * -1 + contentHeight >= content.scrollHeight - 1
                : current === 0

            //  Determine if the scroll position is at the bottom
            const bottom = isReversed
                ? current === 0
                : current + contentHeight >= content.scrollHeight

            //  Assemble the scroll position
            const position: ScrollPosition = {
                height: content.scrollHeight,
                current: current,
                top: top,
                bottom: bottom,
                panel: ScrollPanel[panel]
            }

            //  Update the scrollPosition state
            this.$store.commit(`scrollPosition${panel}Set`, position)
        }, 200),
        //  This determines the behavior of the 'back' button...goBack, or handle mobile navaigation
        routeBack(hotKeyPressed: boolean = false): void {
            //  If no toolbar, return null
            if (!this.toolbar) return null

            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Our toolbar's back button
            let btn = this.toolbar.left && this.toolbar.left[0]

            //  If we are NOT on a mobile device, we always use the global back function
            if (!this.$vuetify.breakpoint.xsOnly && this.displayFull) return goBack(btn)

            //  Else, If we're on step 1, we use the global back function
            if (this.step === 1) goBack(btn)
            //  Else, if we're on step 2, the back button takes use to step 1
            else if (this.step === 2) this.step = 1
            //  Else, If we're on step 3, the back button takes us to step 2
            else if (this.step === 3) this.step = 2
        },
        //  Scroll a panel to a specific position
        scrollTo(position: ScrollPosition) {
            //  Get the content element for the position
            const el = this.$refs[position.panel]

            //  Set the scroll position
            el.scrollTop = position.current
        },
        scrollToBottom(): void {
            //  We use a timeout here to make sure this sticks (<-- hacky, but necessary for now)
            setTimeout(() => {
                //  Get the tri-panel content slot, which is hosting hte message panel
                const dom = document.getElementById('triPanelContent')

                //  Scroll to bottom
                dom.scrollTop = this.centerReversed ? 0 : dom.scrollHeight - 1
            }, 1)
        },
        setStep(step: number): void {
            this.step = step
        }
    }
})
